export default {
    two: {
        title: "译牛灵犀",
        details: "全球首款多人多语言实时AI同声传译APP，开启全新多语言对话",
        qr: "扫码加入沟通",
        ai: "创建AI同传对话",
        exchange: "权益卡兑换"
    },
    three: {
        title: "创建对话",
        details: " 人数限制 / 有效期，保障安全与效率。",
        pagetitle: "扫码与我沟通",
        bottomtext: "嘉宾扫码加入无需登录"
    },
    four: {
        title: "语种选择",
        details: "支持60+语言，打破语言障碍，服务全球用户！",
        titletwo: "输入您的姓名，性别",
        titlethree: "选择您的母语",
        button: "加入对话",
        name: "姓名",
        sex: "性别",
        girl: "女",
        man: "男",
    },
    five: {
        title: "会议管理",
        details: "专为国际展览、团队出国考察及小型多人会议设计",
        one: "扫码与我沟通",
        two: "会议聊天文本",
        three: "开麦/禁言 踢出",
        four: "全员开麦/全员禁言"
    },
    six: {
        title: "AI语音/字幕",
        details: "支持多语言的AI实时语音翻译与字幕生成，无需额外硬件即可轻松突破语言障碍，实现无缝沟通",
        one: "已沟通",
        two: "请点击静音按钮开始对话"
    },
    detail: {
        title: "权益卡兑换步骤"
    },
    video: {
        left: "教学视频",
        title: "使用教学视频"
    },
    download: {
        title: "android安装方式",
        package: "安装包",
    }

}